import { SearchApi } from '../../api';
import { SEARCH_DOCUMENT_TYPES, getSearchDocumentTypesResponse, } from './searchDocumentTypesResponse';
import { getSearchResultsResponse, SEARCH_RESULTS_EMPTY_RESPONSE, } from './searchResultsResponse';
import { getSearchResults } from './searchResults';
import { SearchDocumentType } from '../../api/api.types';
export function mockApi(mockAdapter, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.shouldHaveSearchResults, shouldHaveSearchResults = _c === void 0 ? true : _c, _d = _b.shouldMockDocumentTypes, shouldMockDocumentTypes = _d === void 0 ? true : _d, _e = _b.documentTypesForSearchResults, documentTypesForSearchResults = _e === void 0 ? SEARCH_DOCUMENT_TYPES : _e;
    if (shouldMockDocumentTypes) {
        var documentTypesResponse = getSearchDocumentTypesResponse(documentTypesForSearchResults);
        mockAdapter
            .onGet(SearchApi.getDocumentTypesUrl())
            .reply(200, documentTypesResponse);
    }
    if (shouldHaveSearchResults) {
        mockAdapter.onPost(SearchApi.getSearchUrl()).reply(function (config) {
            var searchRequest = JSON.parse(config.data);
            var searchResponse = getSearchResultsResponse(searchRequest, documentTypesForSearchResults);
            return [200, searchResponse];
        });
    }
    else {
        mockAdapter
            .onPost(SearchApi.getSearchUrl())
            .reply(200, SEARCH_RESULTS_EMPTY_RESPONSE);
    }
    mockAdapter.onPost(SearchApi.getSampleUrl()).reply(function (config) {
        var request = JSON.parse(config.data);
        return [
            200,
            {
                samples: documentTypesForSearchResults
                    .filter(function (documentType) { return documentType !== SearchDocumentType.All; })
                    .map(function (documentType) { return ({
                    documentType: documentType,
                    documents: getSearchResults({
                        documentType: documentType,
                        skip: 0,
                        limit: request.limit,
                        query: request.query,
                    }),
                }); }),
            },
        ];
    });
    mockAdapter.onAny().passThrough();
}
//# sourceMappingURL=mockApi.js.map